import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { AppService } from "../../core/services/app.service";

@Injectable({
    providedIn: 'root'
})

export class BioService {
    constructor(public http: HttpClient) {
    }

    public static bioAPI = AppService.getApiUrl() + '/api/bioUsers/';
    
    saveBio(data) {
        return this.http.post(BioService.bioAPI, data);
    }
    
    getMyBio() {
        return this.http.get(BioService.bioAPI + '/me');
    }
    
}
